export default ({ request }) => ({
  researchInfoListApi (data = {}) {
    return request({
      url: '/digitalCenter/researchInfo/list',
      method: 'post',
      data
    })
  },
  researchInfoSaveApi (data = {}) {
    return request({
      url: '/digitalCenter/researchInfo/save',
      method: 'post',
      data
    })
  },
  researchInfoDetailApi (data = {}) {
    return request({
      url: '/digitalCenter/researchInfo/detail',
      method: 'post',
      data
    })
  },
  researchInfoDelApi (data = {}) {
    return request({
      url: '/digitalCenter/researchInfo/del',
      method: 'post',
      data
    })
  },
  researchInfoImageListApi (data = {}) {
    return request({
      url: '/digitalCenter/researchInfoImage/list',
      method: 'post',
      data
    })
  }
})
